module.exports = __webpack_public_path__ + "img/budgetscheme.75e72532.png";